import { Reveal } from "@/components/Reveal";

const LEADER_IMG = "/navazh.jpg";

export const Leadership = () => (
  <section id="leadership" className="bg-ivory py-28 lg:py-36 border-t border-navy/10" data-testid="leadership-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="absolute -bottom-4 -right-4 w-full h-full border border-gold/60" />
          <img
            src={LEADER_IMG}
            alt="Navazh Jalaludeen, Consultant Cardiac Physiologist"
            className="relative w-full h-auto object-cover object-top"
            data-testid="leadership-image"
          />
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
            About · Founder & Clinical Lead
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-navy leading-tight" data-testid="leader-name">
            Navazh Jalaludeen{" "}
            <span className="text-gold text-lg sm:text-xl lg:text-2xl">MSc (Cardiology), FASE, FBSE</span>
          </h2>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-navy/50 mt-2 mb-8">
            Consultant Cardiac Physiologist | Founder & Clinical Lead
          </p>
        </Reveal>
        {[
          "Navazh Jalaludeen is a Consultant Cardiac Physiologist specialising in echocardiography, with over 20 years of experience in cardiovascular diagnostics and cardiac imaging across NHS hospitals in the UK.",
          "Since 2016, he has worked at Cambridge University Hospitals, where he currently serves as Technical Director for the Research Echocardiography Clinic alongside his role as a part-time Consultant Cardiac Physiologist, combining specialist clinical echocardiography with cardiovascular research.",
          "Navazh holds accreditation from the British Society of Echocardiography (BSE) in both Transthoracic Echocardiography (TTE) and Transoesophageal Echocardiography (TOE) and is certified by the European Association of Cardio-Vascular Imaging (EACVI). He is registered with the Registration Council for Clinical Physiologists (RCCP), holds an MSc in Cardiology, and is a Fellow of the American Society of Echocardiography (FASE) and a Fellow of the British Society of Echocardiography (FBSE).",
          "As Founder and Clinical Lead of Cardio-Vascular Imaging (UK) Ltd (CVI), Navazh brings extensive NHS, independent healthcare and research experience to the delivery of specialist cardiovascular diagnostic services.",
          "Established in 2014, CVI has supported private cardiology clinics for over a decade — providing healthcare and research organisations with flexible access to high-quality cardiac diagnostics, delivered within their existing clinical environments and supported by specialist expertise, advanced cardiac imaging technology and comprehensive reporting.",
        ].map((text, i) => (
          <Reveal key={i} delay={0.1 + i * 0.06}>
            <p className="text-base text-navy/60 leading-relaxed max-w-2xl mb-5">{text}</p>
          </Reveal>
        ))}
        <Reveal delay={0.4}>
          <blockquote className="mt-8 border-l-2 border-gold pl-6">
            <p className="font-serif italic text-lg lg:text-xl text-navy/80 leading-snug">
              “His clinical approach is underpinned by a commitment to diagnostic quality,
              professional standards and patient-centred care.”
            </p>
          </blockquote>
        </Reveal>
      </div>
    </div>
  </section>
);
